module.exports = __webpack_public_path__ + "static/media/plus-icon.41b9b33f.svg";